import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
});

// Interceptor per aggiungere il token alle richieste
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    if (process.env.NODE_ENV === 'development') {
      console.error('Request interceptor error:', error);
    }
    return Promise.reject(error);
  }
);

async function refreshAuthToken() {
  try {
    const refreshToken = localStorage.getItem('refresh_token');
    if (refreshToken) {
      const response = await api.post('/refresh-token', { token: refreshToken });
      const newAccessToken = response.data.access_token;
      localStorage.setItem('token', newAccessToken);
      api.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
      return newAccessToken;
    } else {
      throw new Error('No refresh token available');
    }
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Failed to refresh token:', error);
    }
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    window.location.href = '/login';
    return Promise.reject(error);
  }
}


// Interceptor per gestire le risposte e i refresh del token
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response && error.response.data.error_code === 'email_not_confirmed') {
      return Promise.reject(error);
    }

    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const newToken = await refreshAuthToken();
        if (newToken) {
          originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
          return api(originalRequest);
        }
      } catch (refreshError) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Token refresh failed:', refreshError);
        }
        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
